import clsx from 'clsx';
import { HTMLAttributes } from 'react';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * @component Skeleton
 */
function Skeleton({ className, ...rest }: SkeletonProps) {
  const classes = clsx(`skeleton w-full bg-gray-100 rounded-lg`, className);
  return <div className={classes} {...rest} />;
}

export default Skeleton;
